/*
  Infinite scroll for collection pages, at every screen size.

  Replaces Dawn's numbered pagination: as the shopper nears the bottom the
  next page is fetched and its cards are appended to #product-grid.

  Two Dawn quirks this has to work around:

  1. The class names in snippets/pagination.liquid are inverted —
     paginate.previous renders as .pagination__item--next and paginate.next
     as .pagination__item--prev. Reading "next" from those classes would
     walk backwards. Pages are derived from data-page + the page query
     param instead, which is unambiguous.

  2. settings.animations_reveal_on_scroll is on, so each <li> ships with
     scroll-trigger/animate--slide-in and starts invisible. Dawn's reveal
     observer only picks up elements present at load, so appended cards
     would never become visible. Those classes are stripped on append.

  The trigger is a plain scroll-position check rather than an
  IntersectionObserver on a sentinel — the observer proved unreliable
  against this theme's grid layout, and measuring the grid's own bottom
  edge has no such dependency.

  Pagination stays in the DOM and is only hidden once this initialises, so
  without JS or on failure the numbered links still work.
*/
(function () {
  // How far from the grid's bottom edge to fetch the next page. A flat 800px
  // is most of a phone viewport, which would queue pages far ahead of the
  // shopper, so it is capped to roughly one screen on short viewports.
  function triggerDistance(viewport) {
    return Math.min(800, Math.round(viewport * 0.9));
  }

  function init() {
    var grid = document.getElementById('product-grid');
    var wrapper = document.querySelector('.pagination-wrapper');
    if (!grid || !wrapper) return;

    var nextPage = parseInt(wrapper.getAttribute('data-page') || '1', 10) + 1;
    var lastPage = getLastPage(wrapper);
    var loading = false;
    var done = false;

    document.body.classList.add('js-infinite-scroll');

    function nearBottom() {
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      return grid.getBoundingClientRect().bottom <= viewport + triggerDistance(viewport);
    }

    function check() {
      if (!done && nearBottom()) loadNext();
    }

    function stop() {
      done = true;
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    }

    function restorePagination() {
      // Put the numbered links back rather than stranding the shopper
      // partway through the collection with no way forward.
      document.body.classList.remove('js-infinite-scroll');
      stop();
    }

    function loadNext() {
      if (loading || done) return;
      if (lastPage && nextPage > lastPage) {
        stop();
        return;
      }
      loading = true;

      var url = new URL(window.location.href);
      url.searchParams.set('page', String(nextPage));

      fetch(url.toString())
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var incoming = doc.getElementById('product-grid');

          // main-collection-product-grid.liquid puts id="product-grid" on
          // TWO elements: the real <ul>, and a "No products found" div that
          // renders when a page is empty. Past the last page getElementById
          // finds the empty one — and it HAS children, so a naive length
          // check appends that message over and over.
          if (!incoming || incoming.classList.contains('collection--empty')) {
            stop();
            return;
          }

          var items = Array.prototype.slice.call(incoming.children).filter(
            function (el) {
              return el.classList && el.classList.contains('grid__item');
            }
          );

          if (!items.length) {
            stop();
            return;
          }

          items.forEach(function (item) {
            // importNode adopts the node into this document first. The
            // cards come from a DOMParser document, and appending a
            // foreign node directly is what stopped the first version
            // from rendering anything.
            var card = document.importNode(item, true);
            card.classList.remove('scroll-trigger', 'animate--slide-in');
            card.removeAttribute('data-cascade');
            card.style.removeProperty('--animation-order');
            grid.appendChild(card);
          });

          nextPage += 1;
          loading = false;
          // The appended rows may not reach past the trigger distance on a
          // tall screen, so look again rather than waiting for a scroll.
          window.setTimeout(check, 100);
        })
        .catch(function () {
          restorePagination();
        })
        .then(function () {
          loading = false;
        });
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check(); // in case the first page already sits within trigger distance
  }

  function getLastPage(wrapper) {
    var nodes = wrapper.querySelectorAll('.pagination__item');
    var max = 0;
    for (var i = 0; i < nodes.length; i++) {
      var n = parseInt((nodes[i].textContent || '').trim(), 10);
      if (!isNaN(n) && n > max) max = n;
    }
    return max;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
